module.exports = __webpack_public_path__ + "static/img/box_i.34b615a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/box_i.png
// module id = mekx
// module chunks = 128